var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("box", { attrs: { hideable: true } }, [
    _c("h3", { attrs: { slot: "header" }, slot: "header" }, [
      _c("i", { staticClass: "fas fa-file-medical-alt" }),
      _vm._v(" Logs\n    ")
    ]),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { slot: "body" }, slot: "body" },
      [
        _c("data-table", {
          staticClass: "table table-striped",
          attrs: {
            columns: _vm.columns,
            data: _vm.logs,
            loading: _vm.loading,
            datatableOptions: { order: [[0, "desc"]] }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }